module.exports = __webpack_public_path__ + "img/test01-3.c5926921.jpg";